import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { PatientTimelineLoading } from "./PatientTimelineQrCode.loading";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { PatientTimelineQrCodeProps } from "./PatientTimelineQrCode.types";

export const PatientTimelineQrCodeLoadable = lazy(() =>
  import("./PatientTimelineQrCode")
);

export const PatientTimelineQrCode = (props: PatientTimelineQrCodeProps) => (
  <ErrorBoundary fallback={<ErrorFallback />}>
    <Suspense fallback={<PatientTimelineLoading />}>
      <PatientTimelineQrCodeLoadable {...props} />
    </Suspense>
  </ErrorBoundary>
);
